import { I18n } from 'aws-amplify';
import { dict } from './dictionary';

I18n.putVocabularies(dict);
export const config =
{
    Auth: {
    // REQUIRED - Amazon Cognito Identity Pool ID
        identityPoolId: 'ap-northeast-1:58714912-2a3f-43f4-a49d-58c6d3228fc8', 
    // REQUIRED - Amazon Cognito Region
        region: 'ap-northeast-1', 
    // OPTIONAL - Amazon Cognito User Pool ID
        userPoolId: 'ap-northeast-1_erRAJXesb',
    // OPTIONAL - Amazon Cognito Web Client ID
        userPoolWebClientId: '79ljei5dijbai9t3pdfnqj5tu5', 
    },
    API: {
        endpoints: [
            {
                name: "SmartDeviceAPI",
                endpoint: "https://ze8aoz1ssk.execute-api.ap-northeast-1.amazonaws.com/prod"
            }
        ]
    }};

export const federated = {
    amazon_client_id: 'amzn1.application-oa2-client.3da2e3ebe8d94e6ab9f342f843f4ac2d',
    google_client_id: '958127159336-qfs9v2t8v38f30n7g3g84jnjeqptnrau.apps.googleusercontent.com',
    facebook_app_id:  '2363396620603235'
};

export const actions = [
			{
				icon: "btn--mode-auto-normal",
				title: I18n.get("auto"),
				version: "YL|YN",
				val: 2
			},
			{
				icon: "btn--mode-aperture-normal",
				title: I18n.get("aperture"),
				version: "YN",
				val: 3
			},
			{
				icon: "btn--mode-shutter-normal",
				title: I18n.get("shutter priority"),
				version: "YL|YN",
				val: 4
			},
			{
				icon: "btn--mode-iso-normal",
				title: I18n.get("iso priority"),
				version: "YL|YN",
				val: 9
			},
			{
				icon: "btn--mode-manual-normal",
				title: I18n.get("manual"),
				version: "YL|YN",
				val: 1
			}
	];

export const mIsoSupport = [64, 80, 100, 125, 160, 200, 250, 320, 400, 500, 640, 800, 1000, 1250, 1600, 2000, 2500, 3200];
export const mIsoSupportOnVideo = [64, 80, 100, 125, 160, 200, 250, 320, 400, 500, 640, 800, 1000, 1250, 1600, 2000, 2500, 3200, 4000, 5000, 6400];

export const mShutterSpeedSupport = [
	{ val : "0.00004", text : "1/25000" },
	{ val : "0.00005", text : "1/20000" },
	{ val : "0.0000625", text : "1/16000" },
	{ val : "0.00008", text : "1/12500" },
	{ val : "0.0001", text : "1/10000" },
	{ val : "0.000125", text : "1/8000" },
	{ val : "0.00015625", text : "1/6400" },
	{ val : "0.0002", text : "1/5000" },
	{ val : "0.00025", text : "1/4000" },
	{ val : "0.0003125", text : "1/3200" },
	{ val : "0.0004", text : "1/2500" },
	{ val : "0.0005", text : "1/2000" },
	{ val : "0.000625", text : "1/1600" },
	{ val : "0.0008", text : "1/1250" },
	{ val : "0.001", text : "1/1000" },
	{ val : "0.00125", text : "1/800" },
	{ val : "0.0015625", text : "1/640" },
	{ val : "0.002", text : "1/500" },
	{ val : "0.0025", text : "1/400" },
	{ val : "0.003125", text : "1/320" },
	{ val : "0.004", text : "1/250" },
	{ val : "0.005", text : "1/200" },
	{ val : "0.00625", text : "1/160" },
	{ val : "0.008", text : "1/125" },
	{ val : "0.01", text : "1/100" },
	{ val : "0.0125", text : "1/80" },
	{ val : "0.01666666", text : "1/60" },
	{ val : "0.02", text : "1/50" },
	{ val : "0.025", text : "1/40" },
	{ val : "0.03333333", text : "1/30" },
	{ val : "0.004", text : "1/25" },
	{ val : "0.005", text : "1/20" },
	{ val : "0.06666666", text : "1/15" },
	{ val : "0.07692307", text : "1/13" },
	{ val : "0.1", text : "1/10" },
	{ val : "0.125", text : "1/8" },
	{ val : "0.16666666", text : "1/6" },
	{ val : "0.2", text : "1/5" },
	{ val : "0.25", text : "1/4" },
	{ val : "0.33333333", text : "1/3" },
	{ val : "0.4", text : "1/2.5" },
	{ val : "0.5", text : "1/2" },
	{ val : "0.625", text : "1/1.6" },
	{ val : "0.76923076", text : "1/1.3" },
	{ val : "1", text : "1" },
	{ val : "1.3", text : "1.3" },
	{ val : "1.6", text : "1.6" },
	{ val : "2", text : "2" },
	{ val : "2.5", text : "2.5" },
	{ val : "3.2", text : "3.2" },
	{ val : "4", text : "4" },
	{ val : "5", text : "5" },
	{ val : "6", text : "6" },
	{ val : "8", text : "8" },
	{ val : "10", text : "10" },
	{ val : "13", text : "13" },
	{ val : "15", text : "15" },
	{ val : "20", text : "20" },
	{ val : "25", text : "25" },
	{ val : "30", text : "30" },
	{ val : "60", text : "60" }
];

export const mShutterSpeedSupportOnShutterSpeedMode = [
	{ val : "0.00004", text : "1/25000" },
	{ val : "0.00005", text : "1/20000" },
	{ val : "0.0000625", text : "1/16000" },
	{ val : "0.00008", text : "1/12500" },
	{ val : "0.0001", text : "1/10000" },
	{ val : "0.000125", text : "1/8000" },
	{ val : "0.00015625", text : "1/6400" },
	{ val : "0.0002", text : "1/5000" },
	{ val : "0.00025", text : "1/4000" },
	{ val : "0.0003125", text : "1/3200" },
	{ val : "0.0004", text : "1/2500" },
	{ val : "0.0005", text : "1/2000" },
	{ val : "0.000625", text : "1/1600" },
	{ val : "0.0008", text : "1/1250" },
	{ val : "0.001", text : "1/1000" },
	{ val : "0.00125", text : "1/800" },
	{ val : "0.0015625", text : "1/640" },
	{ val : "0.002", text : "1/500" },
	{ val : "0.0025", text : "1/400" },
	{ val : "0.003125", text : "1/320" },
	{ val : "0.004", text : "1/250" },
	{ val : "0.005", text : "1/200" },
	{ val : "0.00625", text : "1/160" },
	{ val : "0.008", text : "1/125" },
	{ val : "0.01", text : "1/100" },
	{ val : "0.0125", text : "1/80" },
	{ val : "0.01666666", text : "1/60" },
	{ val : "0.02", text : "1/50" },
	{ val : "0.025", text : "1/40" },
	{ val : "0.03333333", text : "1/30" },
	{ val : "0.004", text : "1/25" },
	{ val : "0.005", text : "1/20" },
	{ val : "0.06666666", text : "1/15" },
	{ val : "0.07692307", text : "1/13" },
	{ val : "0.1", text : "1/10" },
	{ val : "0.125", text : "1/8" }
];

export const mShutterSpeedSupportOnVideo = [
	{ val : "0.00004", text : "1/25000" },
	{ val : "0.00005", text : "1/20000" },
	{ val : "0.0000625", text : "1/16000" },
	{ val : "0.00008", text : "1/12500" },
	{ val : "0.0001", text : "1/10000" },
	{ val : "0.000125", text : "1/8000" },
	{ val : "0.00015625", text : "1/6400" },
	{ val : "0.0002", text : "1/5000" },
	{ val : "0.00025", text : "1/4000" },
	{ val : "0.0003125", text : "1/3200" },
	{ val : "0.0004", text : "1/2500" },
	{ val : "0.0005", text : "1/2000" },
	{ val : "0.000625", text : "1/1600" },
	{ val : "0.0008", text : "1/1250" },
	{ val : "0.001", text : "1/1000" },
	{ val : "0.00125", text : "1/800" },
	{ val : "0.0015625", text : "1/640" },
	{ val : "0.002", text : "1/500" },
	{ val : "0.0025", text : "1/400" },
	{ val : "0.003125", text : "1/320" },
	{ val : "0.004", text : "1/250" },
	{ val : "0.005", text : "1/200" },
	{ val : "0.00625", text : "1/160" },
	{ val : "0.008", text : "1/125" },
	{ val : "0.01", text : "1/100" },
	{ val : "0.0125", text : "1/80" },
	{ val : "0.01666666", text : "1/60" },
	{ val : "0.02", text : "1/50" },
	{ val : "0.025", text : "1/40" },
	{ val : "0.03333333", text : "1/30" },
];

export const mEvSupport = [ -2, -1.7, -1.3, -1, -0.7, -0.3, 0, 0.3, 0.7, 1, 1.3, 1.7, 2];
export const mApertureSupport = [ 2.1, 3.5, 5.6];

export const mWbSupport = [
	{ val : "auto", text : "Auto" ,icon: "icon--wb_auto"},
	{ val : "daylight", text : "Outdoor" ,icon: "icon--wb_sun-current"},
	{ val : "shade", text : "Shade" ,icon: "icon--wb_shade-current"},
	{ val : "cloudy-daylight", text : "Cloudy" ,icon: "icon--wb_cloud-current"},
	{ val : "incandescent", text : "Incandescent light 1" ,icon: "icon--wb_inc_1"},
	{ val : "_warmWhiteFluorescent", text : "Incandescent light 2" ,icon: "icon--wb_inc_2"},
	{ val : "_dayLightFluorescent", text : "Daylight color fluorescent light" ,icon: "icon--wb_fluorescent-d-current"},
	{ val : "_dayWhiteFluorescent", text : "Natural white fluorescent light" ,icon: "icon--wb_fluorescent-n-current"},
	{ val : "fluorescent", text : "White fluorescent light" ,icon: "icon--wb_fluorescent-w-current"},
	{ val : "_bulbFluorescent", text : "Light bulb color fluorescent light" ,icon: "icon--wb_fluorescent-l-current"}
];

export const mOptionSupport = [
	{ val: "off", text: I18n.get("off")},
	{ val: "DR Comp", text: I18n.get("DR")},
	{ val: "Noise Reduction", text: I18n.get("noise")},
	{ val: "hdr", text: I18n.get("HDR")}
];



// WEBPACK FOOTER //
// ./src/exports.js